var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "sub-menu",
      staticStyle: { "margin-bottom": "15px" },
      attrs: {
        "slider-color": "primary",
        height: "64",
        "background-color": "transparent"
      }
    },
    [
      _vm.$store.getters.hasPermission("viewBookingAssigned") ||
      _vm.$store.getters.hasPermission("viewAllBookings")
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/booking/flight" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("flight")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("booking.menu.flight")) + " ")
            ],
            1
          )
        : _vm._e(),
      _vm.$store.getters["userProperties"].system_settings
        .is_module_all_bookings_enabled === 2 &&
      (_vm.$store.getters.hasPermission("viewBookingAssigned") ||
        _vm.$store.getters.hasPermission("viewAllBookings"))
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/booking/hotel" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("hotel")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("booking.menu.hotel")) + " ")
            ],
            1
          )
        : _vm._e(),
      _vm.$store.getters["userProperties"].system_settings
        .is_module_all_bookings_enabled === 2 &&
      (_vm.$store.getters.hasPermission("viewBookingAssigned") ||
        _vm.$store.getters.hasPermission("viewAllBookings"))
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/booking/rail" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("train")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("booking.menu.rail")) + " ")
            ],
            1
          )
        : _vm._e(),
      _vm.$store.getters.hasPermission("viewBookingAssigned") ||
      _vm.$store.getters.hasPermission("viewAllBookings")
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/booking/other" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("view_headline")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("booking.menu.other")) + " ")
            ],
            1
          )
        : _vm._e(),
      _vm.$store.getters.hasPermission("bookingMapping") &&
      (_vm.$store.getters["userProperties"].system_settings
        .is_module_travel_service_enabled === 2 ||
        _vm.$store.getters["userProperties"].system_settings
          .is_module_delegation_enabled === 2)
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/booking/mapping" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("fa-user-tag")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("booking.menu.mapping")) + " ")
            ],
            1
          )
        : _vm._e(),
      _c("v-spacer"),
      _vm.$store.getters.hasPermission("viewAllBookings")
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/booking/report" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("show_chart")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("global.menu.reports")) + " ")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }